export const NEWSLETTER_LIST_ID_SUPPLEMENTS = 'YnT7fr';
export const NEWSLETTER_LIST_ID_SKINCARE = 'XViTU6';
